type Translate = (key: string, options?: any) => string;

const METHOD_KEYS: Record<string, string> = {
  app: 'reports.methods.app',
  rfid: 'reports.methods.rfid',
  admin: 'reports.methods.admin',
  ocpp: 'reports.methods.ocpp',
  vendor_api: 'reports.methods.vendorApi',
  kiosk: 'reports.methods.kiosk',
};

export function reportMethodName(translate: Translate, method: string): string {
  return method in METHOD_KEYS ? translate(METHOD_KEYS[method]) : method;
}
